export default __webpack_public_path__ + "static/hot_tub_1-69a141f06cab94165ff6be1bcdbf3a4e.jpg";